/* eslint-disable react/prop-types */
import React, { useState, useEffect } from "react";
import Grid from "@material-ui/core/Grid";
import TextField from "@material-ui/core/TextField";
import FormControl from "@material-ui/core/FormControl";
import InputLabel from "@material-ui/core/InputLabel";
import Select from "@material-ui/core/Select";
import MenuItem from "@material-ui/core/MenuItem";
import FormHelperText from "@material-ui/core/FormHelperText";
import Api from "../../functions/Api";

const FormularioUsuario = React.forwardRef(function FormularioUsuario(
  { modo, usuario, onSubmit },
  ref
) {
  const [ejecutaapi] = Api();

  const [pUsuario, setPUsuario] = useState("");
  const [pClave, setPClave] = useState("");
  const [pCorreo, setPCorreo] = useState("");
  const [pNombre, setPNombre] = useState("");
  const [pApellidoP, setPApellidoP] = useState("");
  const [pApellidoM, setPApellidoM] = useState("");
  const [pIdRol, setPIdRol] = useState("");
  const [roles, setRoles] = useState([]);
  const [rolesLoading, setRolesLoading] = useState(true);
  const [formErrors, setFormErrors] = useState({});

  // Load roles on mount
  useEffect(() => {
    let cancelled = false;
    setRolesLoading(true);
    const body = JSON.stringify({ idRoles: -1 });
    ejecutaapi("obtieneroles", body)
      .then((result) => {
        if (!cancelled) {
          if (result && result.Ok && result.result && result.result[0]) {
            setRoles(result.result[0]);
          } else {
            console.error("Error cargando roles:", result);
            setRoles([]);
          }
          setRolesLoading(false);
        }
      })
      .catch((err) => {
        if (!cancelled) {
          console.error("Error en llamada obtieneroles:", err);
          setRoles([]);
          setRolesLoading(false);
        }
      });
    return () => { cancelled = true; };
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  // Preload data in edit mode
  useEffect(() => {
    if (modo === "editar" && usuario) {
      setPUsuario(usuario.Usuario || "");
      setPClave("");
      setPCorreo(usuario.Correo || "");
      setPNombre(usuario.Nombre || "");
      setPApellidoP(usuario.ApellidoP || "");
      setPApellidoM(usuario.ApellidoM || "");
      setPIdRol(usuario.ID_ROL || "");
    } else {
      setPUsuario("");
      setPClave("");
      setPCorreo("");
      setPNombre("");
      setPApellidoP("");
      setPApellidoM("");
      setPIdRol("");
    }
    setFormErrors({});
  }, [modo, usuario]);

  // Validation function
  const validar = () => {
    const errores = {};
    if (!pUsuario.trim()) errores.pUsuario = "El usuario es requerido";
    else if (pUsuario.trim().length < 3)
      errores.pUsuario = "El usuario debe tener al menos 3 caracteres";
    else if (/^\d+$/.test(pUsuario.trim()))
      errores.pUsuario = "El usuario no puede ser solo números";
    else if (!/^[a-zA-Z0-9._-]+$/.test(pUsuario.trim()))
      errores.pUsuario = "Solo se permiten letras, números, punto, guion y guion bajo";
    if (modo === "insertar" && !pClave.trim())
      errores.pClave = "La contraseña es requerida";
    else if (pClave.trim() && pClave.trim().length < 8)
      errores.pClave = "La contraseña debe tener al menos 8 caracteres";
    else if (pClave.trim() && !/(?=.*[a-z])(?=.*[A-Z])(?=.*\d)/.test(pClave))
      errores.pClave = "Debe incluir mayúscula, minúscula y número";
    if (!pCorreo.trim()) errores.pCorreo = "El correo es requerido";
    else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(pCorreo.trim()))
      errores.pCorreo = "El correo no tiene formato válido";
    if (!pNombre.trim()) errores.pNombre = "El nombre es requerido";
    if (!pApellidoP.trim())
      errores.pApellidoP = "El apellido paterno es requerido";
    if (!pIdRol) errores.pIdRol = "Debe seleccionar un rol";
    return errores;
  };

  // Expose submit method to parent via ref
  React.useImperativeHandle(ref, () => ({
    submit: () => {
      const errores = validar();
      if (Object.keys(errores).length > 0) {
        setFormErrors(errores);
        return false;
      }
      onSubmit({
        pUsuario,
        pClave,
        pCorreo,
        pNombre,
        pApellidoP,
        pApellidoM,
        pIdRol,
        ...(modo === "editar" && usuario
          ? { idUsuario: usuario.ID_USUARIO, Activo: usuario.Activo ? 1 : 0 }
          : {}),
      });
      return true;
    },
  }));

  return (
    <Grid container spacing={2}>
      <Grid item xs={12} sm={6}>
        <TextField
          fullWidth
          label="Usuario"
          value={pUsuario}
          onChange={(e) => setPUsuario(e.target.value)}
          error={!!formErrors.pUsuario}
          helperText={formErrors.pUsuario || ""}
          required
          inputProps={{ maxLength: 50 }}
        />
      </Grid>
      <Grid item xs={12} sm={6}>
        <TextField
          fullWidth
          label="Contraseña"
          type="password"
          value={pClave}
          onChange={(e) => setPClave(e.target.value)}
          error={!!formErrors.pClave}
          helperText={
            formErrors.pClave ||
            (modo === "editar" ? "Dejar vacío para conservar la contraseña actual" : "")
          }
          required={modo === "insertar"}
          inputProps={{ maxLength: 255 }}
        />
      </Grid>
      <Grid item xs={12} sm={6}>
        <TextField
          fullWidth
          label="Correo electrónico"
          value={pCorreo}
          onChange={(e) => setPCorreo(e.target.value)}
          error={!!formErrors.pCorreo}
          helperText={formErrors.pCorreo || ""}
          required
          inputProps={{ maxLength: 150 }}
        />
      </Grid>
      <Grid item xs={12} sm={6}>
        <TextField
          fullWidth
          label="Nombre"
          value={pNombre}
          onChange={(e) => setPNombre(e.target.value)}
          error={!!formErrors.pNombre}
          helperText={formErrors.pNombre || ""}
          required
          inputProps={{ maxLength: 100 }}
        />
      </Grid>
      <Grid item xs={12} sm={6}>
        <TextField
          fullWidth
          label="Apellido Paterno"
          value={pApellidoP}
          onChange={(e) => setPApellidoP(e.target.value)}
          error={!!formErrors.pApellidoP}
          helperText={formErrors.pApellidoP || ""}
          required
          inputProps={{ maxLength: 100 }}
        />
      </Grid>
      <Grid item xs={12} sm={6}>
        <TextField
          fullWidth
          label="Apellido Materno"
          value={pApellidoM}
          onChange={(e) => setPApellidoM(e.target.value)}
          inputProps={{ maxLength: 100 }}
        />
      </Grid>
      <Grid item xs={12} sm={6}>
        <FormControl fullWidth error={!!formErrors.pIdRol} required>
          <InputLabel>Rol</InputLabel>
          <Select
            value={pIdRol}
            onChange={(e) => setPIdRol(e.target.value)}
            disabled={rolesLoading}
          >
            {rolesLoading ? (
              <MenuItem value="" disabled>Cargando roles...</MenuItem>
            ) : roles.length === 0 ? (
              <MenuItem value="" disabled>No se encontraron roles</MenuItem>
            ) : (
              roles.map((rol) => (
                <MenuItem key={rol.ID_ROL} value={rol.ID_ROL}>
                  {rol.DESCRIPCION}
                </MenuItem>
              ))
            )}
          </Select>
          {formErrors.pIdRol && (
            <FormHelperText>{formErrors.pIdRol}</FormHelperText>
          )}
        </FormControl>
      </Grid>
    </Grid>
  );
});

export default FormularioUsuario;
